import axiosInstance from "../utils/axios";

export const GetQueueStats = async (queue) => {
    return await axiosInstance().get(`admin/queue/stats?queue=${queue}`);
}

export const GetQueueFailed = async (queue, limit = 20) => {
    return await axiosInstance().get(`admin/queue/failed?queue=${queue}&limit=${limit}`);
}

export const RetryFailedJobs = async (values) => {
    return await axiosInstance().post("admin/queue/retry-failed", values);
}

export const CleanCompletedJobs = async (values) => {
    return await axiosInstance().post("admin/queue/clean-completed", values);
}

export const CleanFailedJobs = async (values) => {
    return await axiosInstance().post("admin/queue/clean-failed", values);
}

export const BackupQueue = async (values) => {
    return await axiosInstance().post("admin/queue/backup", values);
}

export const ClearQueue = async (values) => {
    return await axiosInstance().post("admin/queue/clear", values);
}

export const PauseQueue = async (values) => {
    return await axiosInstance().post("admin/queue/pause", values);
}

export const ResumeQueue = async (values) => {
    return await axiosInstance().post("admin/queue/resume", values);
}
